module.exports = __webpack_public_path__ + "static/media/banner-service.975ede67.svg";